/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
import React from "react";
export const SvgExternal: React.FC<React.SVGAttributes<SVGElement>> = (
    props
) => (
    <svg viewBox="0 0 24 24" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                fill="currentColor"
                d="M2.75 22a.75.75 0 01-.75-.75V3.75A.75.75 0 012.75 3h8.5a.75.75 0 010 1.5H3.5v16h16v-7.75a.75.75 0 011.5 0v8.5a.75.75 0 01-.648.743L20.25 22H2.75zM16.738 3.06l3.923.04a.73.73 0 01.74.738c.015 1.316.03 2.632.038 3.948.004.569-.569.915-1.052.642-.26-.146-.38-.376-.384-.668l-.021-2.013c0-.05-.004-.101-.006-.165-.069.028-.1.075-.139.112l-6.983 6.983a.844.844 0 01-.338.226.727.727 0 01-.774-1.171l7.063-7.066c.038-.038.089-.067.105-.126-.05-.033-.103-.019-.153-.02-.675-.008-1.35-.01-2.026-.022-.581-.01-.934-.6-.652-1.087.144-.247.371-.354.66-.35z"
            />
            <path d="M0 0h24v24H0z" />
        </g>
    </svg>
);
